import { ModalModule } from 'ngx-bootstrap/modal';

import { SystemCommonModule } from 'src/app/system-common/system-common.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CommissionDetailsSearchComponent } from './commission-details-search/commission-details-search.component';
import { CompensationRoutingModule } from './compensation-routing.module';
import { CompensationService } from './services/compensation.service';
import { EvaluationTrackingSearchComponent } from './evaluation-tracking/evaluation-tracking.component';
import { EndorsementInquirySearchComponent } from './endorsement-inquiry-search/endorsement-inquiry-search.component';

@NgModule({
  declarations: [
    CommissionDetailsSearchComponent,
    EvaluationTrackingSearchComponent,
    EndorsementInquirySearchComponent,
  ],
  imports: [CommonModule, SystemCommonModule, CompensationRoutingModule, ModalModule.forRoot()],
  providers: [CompensationService],
})
export class CompensationModule {}
